/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationGetStationStatsSelfViewersQueryResponse, YoutubeIntegrationGetStationStatsSelfViewersPathParams, YoutubeIntegrationGetStationStatsSelfViewersQueryParams, YoutubeIntegrationGetStationStatsSelfViewers401, YoutubeIntegrationGetStationStatsSelfViewers403 } from "../models/YoutubeIntegrationGetStationStatsSelfViewers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { youtubeIntegrationGetStationStatsSelfViewers } from "../axios/youtubeIntegrationGetStationStatsSelfViewers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const youtubeIntegrationGetStationStatsSelfViewersQueryKey = (station: YoutubeIntegrationGetStationStatsSelfViewersPathParams["station"], params: YoutubeIntegrationGetStationStatsSelfViewersQueryParams) => ["api-v2", { url: '/youtube-integration/v1/stats/viewers/:station/self', params: {station:station} }, ...(params ? [params] : [])] as const

export type YoutubeIntegrationGetStationStatsSelfViewersQueryKey = ReturnType<typeof youtubeIntegrationGetStationStatsSelfViewersQueryKey>

export function youtubeIntegrationGetStationStatsSelfViewersQueryOptions(station: YoutubeIntegrationGetStationStatsSelfViewersPathParams["station"], params: YoutubeIntegrationGetStationStatsSelfViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = youtubeIntegrationGetStationStatsSelfViewersQueryKey(station, params)
        return queryOptions<YoutubeIntegrationGetStationStatsSelfViewersQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetStationStatsSelfViewers401 | YoutubeIntegrationGetStationStatsSelfViewers403>, YoutubeIntegrationGetStationStatsSelfViewersQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return youtubeIntegrationGetStationStatsSelfViewers(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Uses the station `youtubeChannelId`. Responds with 400 when it is not set, and 404 when the channel is not in the live-viewers catalog.
 * @summary Viewer time series for the station YouTube channel
 * {@link /youtube-integration/v1/stats/viewers/:station/self}
 */
export function useYoutubeIntegrationGetStationStatsSelfViewers<TData = YoutubeIntegrationGetStationStatsSelfViewersQueryResponse, TQueryData = YoutubeIntegrationGetStationStatsSelfViewersQueryResponse, TQueryKey extends QueryKey = YoutubeIntegrationGetStationStatsSelfViewersQueryKey>(station: YoutubeIntegrationGetStationStatsSelfViewersPathParams["station"], params: YoutubeIntegrationGetStationStatsSelfViewersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<YoutubeIntegrationGetStationStatsSelfViewersQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetStationStatsSelfViewers401 | YoutubeIntegrationGetStationStatsSelfViewers403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? youtubeIntegrationGetStationStatsSelfViewersQueryKey(station, params)
         

         const query = useQuery({
          ...youtubeIntegrationGetStationStatsSelfViewersQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<YoutubeIntegrationGetStationStatsSelfViewers401 | YoutubeIntegrationGetStationStatsSelfViewers403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}